module.exports = __webpack_public_path__ + "img/close-danger.01d5085b.svg";